import { getField } from 'vuex-map-fields'

export default {
  getField,
  me (state) {
    return state.me
  }
}
